import { useEffect, useRef } from 'react';

interface UseInfiniteScrollObserverOptions {
  hasNextPage?: boolean;
  isPending?: boolean;
  onLoadMore: () => void;
  observerOptions?: IntersectionObserverInit;
}

export function useInfiniteScrollObserver<T extends HTMLElement>({
  hasNextPage,
  isPending,
  onLoadMore,
  observerOptions,
}: UseInfiniteScrollObserverOptions) {
  const loaderRef = useRef<T>(null);

  useEffect(() => {
    const target = loaderRef.current;
    if (!target || !hasNextPage) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry?.isIntersecting && !isPending) {
        onLoadMore();
      }
    }, observerOptions);

    observer.observe(target);

    return () => observer.disconnect();
  }, [hasNextPage, isPending, onLoadMore, observerOptions]);

  return loaderRef;
}
